export abstract class OperatorBaseModal {
    private static instanceIt = 0;

    protected $element: JQuery;
    protected $header?: JQuery;
    protected $body: JQuery;
    private instance: number;

    public isOpen = false;
    protected preventClose = false;

    constructor() {
        this.$element = $('<div class="oldmodal" />');
        this.$body = $('<div class="body" />').appendTo(this.$element);

        OperatorBaseModal.instanceIt++;
        this.instance = OperatorBaseModal.instanceIt;
    }

    public open() {
        if (this.isOpen) return;

        this.isOpen = true;

        const p = $(".app");
        let dim = p.find("> .dim");
        if (dim.length !== 0) {
            dim.addClass("shown").stop(true, false);
        } else {
            dim = $('<div class="dim" />').appendTo(p);
            dim[0].offsetHeight;
            dim.addClass("shown");
        }

        dim.unbind("click.mod" + this.instance).bind("click.mod" + this.instance, () => {
            this.close();
        });

        if (this.$element.stop(true, false).removeClass("closing").parent().length === 0) {
            this.$element.appendTo(p);
            this.$element[0].offsetHeight;
        }

        this.reposition();
        this.$element.addClass("open");

        if (this.onVisibilityChanged !== undefined) this.onVisibilityChanged(true);

        $(window)
            .unbind("resize.mod" + this.instance)
            .bind("resize.mod" + this.instance, () => {
                this.reposition();
            });
    }

    public close() {
        if (!this.isOpen || this.preventClose) return;

        this.isOpen = false;

        const p = $(".app");
        const dim = p.find("> .dim");
        if (dim.length !== undefined) {
            dim.unbind("click.mod" + this.instance);
            dim.removeClass("shown")
                .stop(true, false)
                .delay(300)
                .queue((e) => {
                    dim.remove();
                    e();
                });
        }

        $(window).unbind("resize.mod" + this.instance);

        if (this.onVisibilityChanged !== undefined) this.onVisibilityChanged(false);

        this.$element.addClass("closing")[0].offsetHeight;
        this.$element
            .removeClass("open")
            .stop(true, false)
            .delay(450)
            .queue((e) => {
                this.$element.removeClass("closing").detach();

                e();
            });
    }

    public reposition() {
        const windowHeight = $(window).height();
        const windowWidth = $(window).width();

        if (this.beforeResize !== undefined) this.beforeResize(windowWidth, windowHeight);

        this.$element.removeAttr("style");
        const reachedMaxWidth = windowWidth - 30 < this.$element.width();
        const reachedMaxHeight = windowHeight - 30 < this.$element.height();

        this.$element.css({
            top: reachedMaxHeight ? 15 : (windowHeight - this.$element.height()) / 2,
            left: reachedMaxWidth ? 15 : (windowWidth - this.$element.width()) / 2,
        });

        if (reachedMaxHeight) this.$element.css("height", windowHeight - 30);
        else this.$element.css("height", "auto");
    }

    protected abstract onVisibilityChanged(visible: boolean): void;

    protected abstract beforeResize(width: number, height: number): void;
}
